import { Spinner, SpinnerSize } from 'office-ui-fabric-react';
import * as React from 'react';

// property interface
export interface IProps {
  AddSpinner?: boolean;
  AbsolutePossition?: boolean;
};

export default class Loading extends React.Component<IProps> {
  public state = { isLoading: false };
  public classNames = 'mipaloading ';

  constructor(props: IProps | Readonly<IProps>) {
    super(props)
    this.state = { isLoading: false };
    if (this.props.AbsolutePossition) this.classNames += 'pstn-absolute'
  }

  public ShowHideLoading = (show) => {
    this.setState({ isLoading: show })
  }

  public render() {
    return (
      <span>
        {this.state.isLoading ? (
          <div className={this.classNames}>
            {this.props.AddSpinner &&
              <Spinner size={SpinnerSize.medium} />
            }
          </div>
        ) : null}
      </span>

    )
  }
}
